export default "__VITE_ASSET__BKgnjw4T__"